import React, { useState } from 'react'
import mail from './images/mail.svg'
import { BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs'
import { MdKeyboardArrowDown } from 'react-icons/md'


const Footer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isAbout, setAbout] = useState(false)

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const keyDown = () => {
        setAbout(!isAbout)
    };
    return (
        <>
            <div className="">
                <div className="py-4 flex md:flex-row flex-col items-center justify-center border-t border-t-gray-100 border-b-gray-100 border-b">
                    <img src={mail} alt="mail" width={'50px'} />
                    <div className="md:px-8 md:text-left text-center">
                        <h1 className='text-[1.5rem] tracking-wide high text-[#B5D1B3]'>Subscribe for updates</h1>
                        <h1 className='md:text-[.9rem]  text-[.8rem] tracking-wide'>Receive news and updates straight to your inbox</h1>
                    </div>
                    <div className="flex lg-py-0 py-4  lg:ml-[5rem] justify-center ">
                        <button className='border text-[.8rem] text-center border-[#004A8B] py-3 text-[#004A8B] hover:text-[white] hover:bg-[#004A8B] px-7'>SUSCRIBE</button>
                    </div>
                </div>

                <div className="hidden md:block relative border-b border-b-gray-100">
                    
                    <div className="justify-center items-center  flex ">
                        <button><h1 className='text-[#004A8B] hover:text-[#B0C7DB] font-black
                         my-[1rem] tracking-wider text-[1.1rem] focus:outline-none mx-[1.7rem] flex' type='button' onClick={toggleDropdown}>What we do<MdKeyboardArrowDown className='text-[1.5rem] mx-2' /></h1></button>

                        <button><h1 className='text-[#004A8B] font-black
                         my-[1rem] tracking-wider text-[1.1rem]   flex hover:text-[#B0C7DB]   mx-[2rem]' type='button' onClick={keyDown}>About us <MdKeyboardArrowDown className='text-[1.5rem] mx-2' /></h1></button>

                        <button><h1 className='text-[#004A8B] text-[1.1rem] hover:text-[#B0C7DB] font-black mx-2'>News</h1></button>
                        <button><h1 className='text-[#004A8B] text-[1.1rem] hover:text-[#B0C7DB] font-black mx-8'>Connect</h1></button>

                        <button className=''><BsFacebook className='hover:text-[#B0C7DB] text-[#004A8B]  text-lg' /></button>
                        <button className=''><BsInstagram className='hover:text-[#B0C7DB] text-[#004A8B] text-lg mx-2 ' /></button>
                        <button className=''><BsLinkedin className='hover:text-[#B0C7DB] text-[#004A8B]  text-lg mx-1 ' /></button>
                    </div>
                </div>

                <div className="flex md:flex-row justify-center flex-col-reverse   py-7">
                    <h1 className='text-center  text-gray-400 tracking-wider text-[.77rem]'>Copyright © 2023 LAWD. All Rights Reserved. </h1>
                    <button className='mx-4 text-gray-400 tracking-wider text-[.77rem] hover:text-[#004A8B]'>Privacy Policy</button>
                </div>


                <div className={`${isOpen ? 'visible' : 'hidden'} relative  w-[10%] top-[-4.8rem]  ml-[23rem] items-center text-center justify-center focus:outline-none`}>
                    <div className="w-full">
                        <a className=' text-[#004A8B] hover:text-[#B0C7DB]' href="/ ">For Sale</a>

                    </div>
                    <div className="">
                        <a className=' text-[#004A8B] hover:text-[#B0C7DB]' href="/">Our track record</a>
                    </div>
                    <div className="w-full ">
                        <select name="" id="" className=' w-full hover:text-[#B0C7DB]  text-[#004A8B]'>
                            <option className='hover:text-[#B0C7DB]  text-[#004A8B]' value="">Our Services</option>
                            <option className='hover:text-[#B0C7DB]  text-[#004A8B]' value="">Advisory</option>
                            <option className='hover:text-[#B0C7DB]  text-[#004A8B]' value="">Transactions</option>
                            <option className='hover:text-[#B0C7DB]  text-[#004A8B]' value="">Valuations</option>
                        </select>
                    </div>

                </div>


                <div className={`${isAbout ? 'visible' : 'hidden'}   relative w-[13%] top-[-4.8rem]  ml-[34rem] items-center text-center justify-center`}>
                    <div className="w-full ">
                        <a className=' text-[#004A8B] hover:text-[#B0C7DB]' href="/ ">Our Story</a>
                    </div>
                    <div className="">
                        <a className=' text-[#004A8B] hover:text-[#B0C7DB]' href="/">Our Communities</a>
                    </div>
                    <div className="">
                        <a className=' text-[#004A8B] hover:text-[#B0C7DB]' href="/">Meet our team</a>
                    </div>
                    <div className="">
                        <a className=' text-[#004A8B] hover:text-[#B0C7DB]' href="/">Join our team</a>
                    </div>


                </div>

            </div>
        </>
    )
}

export default Footer